import React from 'react';
import PaymentStepLayout from '../PaymentStepLayout';
import { Address } from '../../../../models';

interface PaymentAddressStepProps {
  setStepSelected: React.Dispatch<React.SetStateAction<number>>;
  stepSelected: number;
  address: Address;
}

function PaymentAddressStep({
  setStepSelected,
  stepSelected,
  address,
}: PaymentAddressStepProps) {
  const addressInfoToShow = [
    { label: 'País', value: address?.country },
    { label: 'Estado', value: address?.state },
    { label: 'Municipio', value: address?.municipality },
    { label: 'Calle/Avenida/Esquina', value: address?.address1 },
    { label: 'Edif/Apto/Piso/Casa', value: address?.address2 },
  ].filter((info) => info.value && info.value !== '');

  return (
    <PaymentStepLayout
      title="Dirección de facturación"
      num={3}
      collapsed={stepSelected === 3}
      setStepSelected={setStepSelected}
    >
      <div className="my-3 mt-5 pl-2 flex  flex-wrap">
        {addressInfoToShow.length === 0 && (
          <div className="text-purple-300 font-medium">
            No se tiene registro sobre la dirección de facturación de esta
            empresa.
          </div>
        )}
        {Object.keys(addressInfoToShow).map((info, index) => (
          <div key={index} className="w-full sm:w-1/2 my-2">
            <span className="text-purple-300 font-semibold">
              {addressInfoToShow[info].label}:{' '}
            </span>
            {addressInfoToShow[info].value}
          </div>
        ))}
      </div>
    </PaymentStepLayout>
  );
}

export default PaymentAddressStep;
